import { gql } from '@apollo/client';

export const INCOME_FRAGMENT = gql`
  fragment Income on Income {
    id
    mainJobIncome
    sideJobIncome
  }
`;

export const INCOME = gql`
  query income {
    request {
      id
      employee {
        id
      }
      profile {
        id
        birthday
        income {
          ...Income
        }
        formerJobs {
          id
          paymentAmount
        }
      }
    }
  }
  ${INCOME_FRAGMENT}
`;

type Income = {
  id: string;
  mainJobIncome: string;
  sideJobIncome: string;
};

type FormerJob = {
  id: string;
  paymentAmount: string;
};

export type Profile = {
  id: string;
  birthday: string;

  formerJobs: FormerJob[];
  income: Income;
};
